import { readFileSync } from 'fs';
import { fileURLToPath } from 'url';
import { dirname, join } from 'path';
import type { AstroIntegration, HookParameters } from 'astro';

export interface UmamiIntegrationOptions {
  shareUrl: string | false;
}

export interface OddmiscIntegrationOptions {
  umami?: UmamiIntegrationOptions;
}

type AstroConfigSetupParams = HookParameters<'astro:config:setup'>;

function injectUmamiRuntime(shareUrl: string | false): string | undefined {
  if (!shareUrl) return;

  let runtimeCode = '';
  try {
    const __dirname = dirname(fileURLToPath(import.meta.url));
    // dist/astro/ → dist/runtime/client.global.js
    const runtimePath = join(__dirname, '../runtime/client.global.js');
    runtimeCode = readFileSync(runtimePath, 'utf-8');
  } catch {
    console.warn('[oddmisc] 无法读取运行时文件，已跳过客户端注入');
    return;
  }

  return `
// oddmisc Umami Runtime
${runtimeCode}

if (typeof window !== 'undefined' && typeof __oddmiscRuntime !== 'undefined') {
  __oddmiscRuntime.initUmamiRuntime(${JSON.stringify({ shareUrl })});
}
`;
}

export function umami(options: UmamiIntegrationOptions): AstroIntegration {
  return {
    name: 'oddmisc-umami-integration',
    hooks: {
      'astro:config:setup': ({ injectScript }: AstroConfigSetupParams) => {
        const code = injectUmamiRuntime(options.shareUrl);
        if (code) injectScript('page', code);
      }
    }
  };
}

export function oddmisc(options: OddmiscIntegrationOptions = {}): AstroIntegration {
  return {
    name: 'oddmisc-integration',
    hooks: {
      'astro:config:setup': ({ injectScript }: AstroConfigSetupParams) => {
        if (options.umami) {
          const code = injectUmamiRuntime(options.umami.shareUrl);
          if (code) injectScript('page', code);
        }
      }
    }
  };
}
